import React from "react";
import DashboardLayout from "../../Components/Common/DashboardLayout";
import NCProTableComponents from "../../Components/Pages/NCPro/NCProTableComponents";

export default function DataTable() {

  const content = {
    label: "Data table",
    component: <NCProTableComponents label="datatable" />
  }

  return (
    <DashboardLayout content={content} />
  );
};